import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";
import BesoinEditor from "../BesoinEditor";
import Input from "../../../Atoms/Input";
import styled from "styled-components";
import React from "react";
import { useState } from "react";
import { SDE2024MultiSelectOptionsA } from "../../../Utils/Listings"

function valuesToOptions(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value));
}

const PopA1 = (props) => {


    const defaultValues = props.defaultValues || {};

    function stringOrNonEmptyArray(value) {
    

        if (value === undefined)  {
            return false
        }
        if (Array.isArray(value) && value.length === 0) {
            return false;
        }

        if (Array.isArray(value) && value.length !== 0) {
            return true;
        }

        if (value === '') {
            return false
        }
        else {
            return true
        }
    }

    const { i18n } = useTranslation('common');
    const [showArtisanat, setShowArtisanat ] = useState(stringOrNonEmptyArray(defaultValues.artisanatType));
    const [showMobilier, setShowMobilier] = useState(stringOrNonEmptyArray(defaultValues.mobilierType));

    const archiIntList = SDE2024MultiSelectOptionsA.archiIntListA(i18n.language);
    const critereList = SDE2024MultiSelectOptionsA.critereListA(i18n.language);
    const rechercheProcess = SDE2024MultiSelectOptionsA.rechercheProcessA(i18n.language);
    const rechercheProduction = SDE2024MultiSelectOptionsA.rechercheProductionA(i18n.language);
    const rechercheFlex = SDE2024MultiSelectOptionsA.rechercheFlexA(i18n.language);
    const rechercheModel = SDE2024MultiSelectOptionsA.rechercheModelA(i18n.language);
    const artisanatType = SDE2024MultiSelectOptionsA.artisanatTypeA(i18n.language);
    const artisanatScale = SDE2024MultiSelectOptionsA.artisanatScaleA(i18n.language);
    const artisanatExport = SDE2024MultiSelectOptionsA.artisanatExportA(i18n.language);
    const mobilierType = SDE2024MultiSelectOptionsA.mobilierTypeA(i18n.language);
    const mobilierExport = SDE2024MultiSelectOptionsA.mobilierExportA(i18n.language);
    const mobilierMaterial = SDE2024MultiSelectOptionsA.mobilierMaterialA(i18n.language);
    const mobilierScale = SDE2024MultiSelectOptionsA.mobilierScaleA(i18n.language);

    const handleMobilierCheckboxChange = (e) => {
        setShowMobilier(e.target.value === "oui");
    };

    const handleArtisanatCheckboxChange = (e) => {
        setShowArtisanat(e.target.value === "oui");
    };

    return (<>
        {/* <BlueButton onClick={(e) => { e.preventDefault(); cvInputRef.current?.click() }}><img src='/img/import.png' />{i18n.language === "fr" ? "Document de présentation de l'entreprise" : "Company presentation document"}</BlueButton>{currentCVPath && <ExistingCV path={currentCVPath} removeCV={removeCV} />}<br /><br />
        <input hidden name="document" ref={cvInputRef} onChange={receiveFile} style={{ width: "100%" }} type="file" accept="application/pdf" /> */}
        <div className="dropdown-container">
            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Quelle est votre spécialité?*" : "What is your speciality?"}</h2>
            <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
            <br></br>

            <ReactSelect
                name="type_projets"
                options={archiIntList}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                style={{ marginBottom: '20px', marginTop: '20px' }}
                required
                defaultValue={valuesToOptions(defaultValues.type_projets, archiIntList)}
            />
            <br></br>


            <Input type="text" style={{ width: "100%", zIndex: "0" }} name="type_projets_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.type_projets_precisions} />

            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Quel est le profil des sociétés que vous recherchez ?*" : "What type of company are you looking for?*"}</h2>
            <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
            <br></br>
            <ReactSelect
                name="criteres"
                options={critereList}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                required
                defaultValue={valuesToOptions(defaultValues.criteres, critereList)}
            />
            <br></br>

            <Input type="text" style={{ width: "100%", zIndex: "0" }} name="criteres_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.criteres_precisions} />

            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Quel est le type d'offre(s)/savoir-faire recherché(s)?*" : "What type of service(s)/expertise are you looking for?*"}</h2>
            <br></br>
            <h2 style={{ marginBottom: '20px' }}>{i18n.language === "fr" ? "Artisanat d'art" : "Arts and crafts"}</h2>

            <div className='checkboxlist'>
                <label>
                    <input
                        required
                        type="radio"
                        name="artisanat"
                        value="oui"
                        checked={showArtisanat}
                        onChange={handleArtisanatCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Oui" : "Yes"}<br />
                </label>
                <label>
                    <input
                        required
                        type="radio"
                        name="artisanat"
                        value="non"
                        checked={!showArtisanat}
                        onChange={handleArtisanatCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Non" : "No"}<br />
                </label>
            </div>
            {showArtisanat && (
                <>
                    <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Type de savoir-faire*" : "Type of skills*"}</h3>
                    <br></br>

                    <ReactSelect
                        name="artisanatType"
                        options={artisanatType}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.artisanatType, artisanatType)}
                    />
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Échelle de production*" : "Scale of production*"}</h3>
                    <br></br>

                    <ReactSelect
                        name="artisanatScale"
                        options={artisanatScale}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.artisanatScale, artisanatScale)}
                    />
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Projets à l'export*" : "Projects for export*"}</h3>
                    <br></br>


                    <ReactSelect
                        name="artisanatExport"
                        options={artisanatExport}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.artisanatExport, artisanatExport)}
                    />
                    <br></br>
                    <Input type="text" style={{ width: "100%", zIndex: "0" }} name="artisanat_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.artisanat_precisions} />

                </>
            )}



            <h2 style={{ marginBottom: '20px', marginTop: '20px' }}>{i18n.language === "fr" ? "Mobilier" : "Furniture"}</h2>
            <div className='checkboxlist'>
                <label>
                    <input
                        required
                        type="radio"
                        name="mobilier"
                        value="oui"
                        checked={showMobilier}
                        onChange={handleMobilierCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Oui" : "Yes"}<br />
                </label>
                <label>
                    <input
                        required
                        type="radio"
                        name="mobilier"
                        value="non"
                        checked={!showMobilier}
                        onChange={handleMobilierCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Non" : "No"}<br />
                </label>
            </div>
            {showMobilier && (
                <>
                    <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Type de mobilier*" : "Type of furniture*"}</h3>
                    <ReactSelect
                        name="mobilierType"
                        options={mobilierType}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}

                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierType, mobilierType)}
                    />
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Type de matériaux*" : "Type of materials*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierMaterial"
                        options={mobilierMaterial}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierMaterial, mobilierMaterial)}
                    />
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Échelle de production*" : "Scale of production*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierScale"
                        options={mobilierScale}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierScale, mobilierScale)}
                    />
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Projets à l'export*" : "Projects for export*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierExport"
                        options={mobilierExport}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierExport, mobilierExport)}
                    />
                    <br></br>

                    <Input type="text" style={{ width: "100%", zIndex: "0" }} name="mobilier_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.mobilier_precisions} />
                </>
            )}
            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Que recherchez-vous spécifiquement dans le savoir-faire des artisans, éditeurs et fabricants français engagés dans la transition durable ?*" : "What specifically are you looking for in the skills of French artisans, editors and manufacturers committed to sustainability transitions?*"}</h2>
            <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
            <br></br>

            <h3>{i18n.language === "fr" ? "Nouveaux modèles de l'économie circulaire*" : "New circular economy models*"}</h3>
            <br></br>

            <ReactSelect
                name="rechercheModel"
                options={rechercheModel}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheModel, rechercheModel)}
            />
            <br></br>
            <h3>{i18n.language === "fr" ? "Process innovants*" : "Innovative processes*"}</h3>
            <br></br>
            <ReactSelect
                name="rechercheProcess"
                options={rechercheProcess}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheProcess, rechercheProcess)}
            />
            <br></br>
            <h3>{i18n.language === "fr" ? "Production locale*" : "Local production*"}</h3>
            <br></br>
            <ReactSelect
                name="rechercheProduction"
                options={rechercheProduction}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheProduction, rechercheProduction)}
            />
            <br></br>
            <h3>{i18n.language === "fr" ? "Flexibilité d'usage*" : "Flexibility of use*"}</h3>
            <br></br>
            <ReactSelect
                name="rechercheFlex"
                options={rechercheFlex}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheFlex, rechercheFlex)}
            />
            <br></br>


            <Input type="text" style={{ width: "100%", zIndex: "0" }} name="recherche_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.recherche_precisions} />

        </div>



        <br />
        <h2 className="formtitle" >{i18n.language === 'fr' ? "Quel est votre projet(s) en cours ou à venir pour le(s)quel(s) vous recherchez des savoir-faire français ?" : "Share your achievements in sustainable design in the context of space projects"}*</h2>
        <BesoinEditor projets={props.projets} setDeletedProjets={props.setDeletedProjets} setProjets={props.setProjets} />
    </>);
}

const ExistingCVContainer = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    margin-left: 20px;

    a {
        text-decoration: none;
        color: #777;
        font-size: 14px;
    }
`;

const ExistingCV = (props) => {

    const { i18n } = useTranslation('common');

    return (
        <ExistingCVContainer>
            <a href={props.path} target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Voir le document" : "View document"}</a>
            <span style={{ cursor: "pointer" }} onClick={props.removeCV}><img src='/img/x_noir.png' alt=""/></span>
        </ExistingCVContainer>
    )
};


export default PopA1;